import { adminBaseUrl, imageUrl, userBaseUrl,
   commonBaseUrl, 
   otpUrl, cpBaseUrl,
   nextBaseUrl, nexttradBaseUrl
   } from "./baseUrl";
import axios from "axios";

const adminAxiosInstance = axios.create({
  baseURL: adminBaseUrl,
});

export const userAxiosInstance = axios.create({
  baseURL: userBaseUrl,
}); 

export const imageAxiosInstance = axios.create({
  baseURL: imageUrl
})
export const otpAxiosInstance = axios.create({
  baseURL: otpUrl
})
export const cpAxiosInstance = axios.create({
  baseURL: cpBaseUrl
})



export const commonAxiosInstance = axios.create({
  baseURL: commonBaseUrl,
});
export const nextadminAxiosInstance = axios.create({
  baseURL: nextBaseUrl,
});
export const nextAxiosInstance = axios.create({
  baseURL: nexttradBaseUrl,
});

export default adminAxiosInstance;
